import { FAQsStoryblok, RichTextStoryblok } from "@/types/blok-types";
import clsx from "clsx";

import {
  AccordionContent,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger
} from "@/components/atoms/Accordions/Accordion/ClientAccordion";
import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import styles from "./faqs.module.css";

const FAQs = ({ blok, preview }: { blok: FAQsStoryblok; preview: boolean }) => {
  const Title = () =>
    !blok?.title ? null : <h2 className={styles.title}>{blok.title}</h2>;

  return (
    <div
      className={clsx(styles.root, "faqs-blok")}
      data-layout="blok"
      data-container="small"
    >
      <div>
        <Title />
        <AccordionRoot className={styles.faqs}>
          {blok?.questions.map((q) => (
            <AccordionItem key={q._uid}>
              <AccordionTrigger>{q.question}</AccordionTrigger>
              <AccordionContent className={styles.answer}>
                {q.answer?.map((answer: RichTextStoryblok) => (
                  <StoryblokComponent
                    blok={answer}
                    key={answer._uid}
                    preview={preview}
                  />
                ))}
              </AccordionContent>
            </AccordionItem>
          ))}
        </AccordionRoot>
      </div>
    </div>
  );
};

export default FAQs;
